import { BrandMode } from "@Light/services/lightTypes";
import { useContext } from "react";
import { ScaffoldContext } from "./context";
import { Scaffold } from "./scaffold";

export function useScaffold(): Scaffold {
  const scaffold = useContext(ScaffoldContext);
  if (!scaffold) {
    throw new Error("attempting to access scaffold with none defined");
  }

  return scaffold;
}

export function useIsSubtleBrand(): boolean {
  return useScaffold().page.brandMode === BrandMode.Subtle;
}
